import { ArrowUUpLeft } from '@phosphor-icons/react/dist/ssr/ArrowUUpLeft'
import { Compass } from '@phosphor-icons/react/dist/ssr/Compass'
import { Images } from '@phosphor-icons/react/dist/ssr/Images'
import { siteConfig } from '../../config/site'
import { NavIconCv, NavIconLogo } from './nav-icons'
import '../layout/site-layout.css'
import './portfolio-navigation.css'

type Section = 'home' | 'work'
type Props = { section: Section; backHref?: string; backLabel?: string }

/** One DOM tree and breakpoint for navigation in both site bundles. */
export function PortfolioNavigation({ section, backHref, backLabel = 'Go back' }: Props) {
  const items = [
    { section: 'home', label: 'Home', href: '/', Icon: Compass },
    { section: 'work', label: 'Work', href: siteConfig.workIndexUrl, Icon: Images },
  ] as const
  const externalCv = /^https?:\/\//i.test(siteConfig.cvUrl)

  return <>
    <div className="portfolio-nav-backdrop" aria-hidden="true" />
    <nav className="portfolio-navigation" aria-label="Primary">
      <a className="portfolio-nav-brand portfolio-nav-disc" href="/" aria-label="Gosha home" title="Gosha home"><NavIconLogo /></a>
      <div className="portfolio-nav-middle">
        {backHref && <a className="portfolio-nav-back portfolio-nav-disc" href={backHref} aria-label={backLabel} title={backLabel}><ArrowUUpLeft size={20} aria-hidden="true" /></a>}
        <div className="portfolio-nav-links">
          {items.map(({ section: key, label, href, Icon }) => <a key={key} href={href} aria-label={label} title={label} aria-current={section === key ? 'page' : undefined}><Icon size={18} aria-hidden="true" /></a>)}
        </div>
      </div>
      <a className="portfolio-nav-cv portfolio-nav-disc" href={siteConfig.cvUrl} {...(externalCv ? { target: '_blank', rel: 'noreferrer' } : {})} aria-label={externalCv ? 'Resume (opens in new tab)' : 'Resume'} title="Resume"><NavIconCv /></a>
    </nav>
  </>
}
